// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__GWqcZ","blockMsg":"Message_blockMsg__MDWxt","avatar":"Message_avatar__ZADgQ","avatarBg":"Message_avatarBg__Axqp9","nameAuthor":"Message_nameAuthor__-TmCh"};